import { useState } from 'react'
import { ShowTGAlert } from 'Helpers/ShowTGAlert'
import { useForm } from 'react-hook-form'
import customerService from 'Services/customerService'

interface UpdateTierModalProps {
  setTestTierModal: (show: boolean) => void
  msisdn: string | undefined
}

type formProp = {
  cashbackTierStartDate: string
  productType: string
}

const SetBoostCycleModal: React.FC<UpdateTierModalProps> = ({ setTestTierModal, msisdn }) => {
  const { register, handleSubmit } = useForm<formProp>()
  const { showAlert } = ShowTGAlert()
  const [loading, setLoading] = useState(false)

  const onSubmit = async (data: formProp) => {
    setLoading(true)
    const msis = encodeURIComponent(msisdn ?? '')

    const payload = {
      cashbackTierStartDate: new Date(data.cashbackTierStartDate).toISOString(),
      productType: data.productType,
    }

    await customerService.setBoastCycleStateDate(msis, payload).then(
      () => {
        showAlert({
          message: 'Boost cycle start date Updated successfully',
          show: true,
          title: 'Done!',
          type: 'success',
        })
        setTestTierModal(false)
      },
      (error: { response: { data: { error: string } } }) => {
        showAlert({
          message: error.response.data.error,
          show: true,
          title: 'Error',
          type: 'error',
        })
      },
    )
    setLoading(false)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className='mt-3'>
      <div className='form-group mb-3'>
        <label htmlFor='productType' className='form-label fw-medium'>
          Product Type
        </label>
        <select id='productType' className='form-control' {...register('productType')}>
          <option value={''}>--option--</option>
          <option value={'PMS'}>PMS</option>
          <option value={'AGO'}>AGO</option>
        </select>
      </div>

      <div className='mb-3'>
        <label htmlFor='cashbackTierStartDate' className='form-label fw-medium'>
          Cashback Tier Start Date
        </label>
        <input
          type='datetime-local'
          id='cashbackTierStartDate'
          {...register('cashbackTierStartDate', { required: true })}
          className='form-control'
          disabled={loading}
        />
      </div>

      <div className='d-flex justify-content-end gap-2'>
        <button
          type='button'
          className='btn btn-secondary'
          onClick={() => setTestTierModal(false)}
          disabled={loading}
        >
          Cancel
        </button>
        <button type='submit' className='btn btn-default' disabled={loading}>
          {loading ? (
            <span className='spinner-border spinner-border-sm text-dark'></span>
          ) : (
            'Update'
          )}
        </button>
      </div>
    </form>
  )
}

export default SetBoostCycleModal
